/**
 * ViewModeToggle — herbruikbare blokjes/rijen schakelaar.
 *
 * Props:
 *   - value: "blokjes" | "rijen"
 *   - onChange: (next: "blokjes" | "rijen") => void
 *   - testid (optioneel): basis-testid (default "viewmode-toggle")
 *
 * In de huisstijl: twee knoppen met hun naam erin, de actieve op inkt. Het ontwerp
 * schrijft woorden voor in plaats van iconen — "blokjes" en "rijen" zijn duidelijker
 * dan twee tekeningetjes die je uit elkaar moet houden. De aria-labels en de
 * aria-pressed-standen blijven zoals ze waren, zodat schermlezers niets merken.
 */
import React from "react";

const BASIS = {
  minHeight: 32,
  padding: "0 var(--ruimte-5)",
  border: "none",
  fontSize: "var(--fs-sm)",
  fontFamily: "var(--font-tekst)",
  fontWeight: "var(--fw-normaal)",
  cursor: "pointer",
  transition: "var(--overgang-kleur)",
};

const AAN = { background: "var(--ink)", color: "var(--text-inverse)" };
const UIT = { background: "var(--wit)", color: "var(--text-soft)" };

export default function ViewModeToggle({ value, onChange, testid = "viewmode-toggle" }) {
  const isBlokjes = value !== "rijen"; // default = blokjes als value ontbreekt
  return (
    <div
      role="group"
      aria-label="Weergave wisselen"
      data-testid={testid}
      style={{
        display: "inline-flex", alignItems: "center", overflow: "hidden",
        borderRadius: "var(--radius)", border: "1px solid var(--border-subtle)",
        background: "var(--wit)",
      }}
    >
      <button
        type="button"
        aria-label="Blokjes-weergave"
        aria-pressed={isBlokjes}
        data-testid={`${testid}-blokjes`}
        onClick={() => onChange("blokjes")}
        style={{ ...BASIS, ...(isBlokjes ? AAN : UIT) }}
      >
        blokjes
      </button>
      <button
        type="button"
        aria-label="Rijen-weergave"
        aria-pressed={!isBlokjes}
        data-testid={`${testid}-rijen`}
        onClick={() => onChange("rijen")}
        style={{ ...BASIS, ...(!isBlokjes ? AAN : UIT) }}
      >
        rijen
      </button>
    </div>
  );
}
